import { AccessControlInputType } from '../../../infra/startup/types';
import AccessControlInterfaceV1 from './AccessControlInterfaceV1';
import { AccessControlInterfaceType } from './types';

let accessControlInterfaceV1: AccessControlInterfaceV1;

export function getAccessControlInterfaceV1(): AccessControlInterfaceType {
  return accessControlInterfaceV1.getInterface();
}

export function clearAccessControlInterfaceSingleton(): void {
  accessControlInterfaceV1 = undefined;
}

/**
 * Initialize the AccessControl interface V1
 *
 * @param options - Configuration for AccessControl
 * @returns AccessControl interface object
 */
export async function initializeAccessControlInterfaceV1({
  accessControl
}: {
  accessControl: AccessControlInputType;
}): Promise<AccessControlInterfaceType> {
  if (accessControlInterfaceV1) return accessControlInterfaceV1.getInterface();

  accessControlInterfaceV1 = new AccessControlInterfaceV1();

  return accessControlInterfaceV1.getInterface();
}
